import type { ZoraComponentMeta } from '../authoring';
export const formActionsMeta = {
  name: 'FormActions',
  category: 'component',
  directManifestNode: false,
  allowedChildren: [],
  note: 'Internal form action helper.',
  props: {},
} as const satisfies ZoraComponentMeta;
